module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mobile-stacked-1-image-1-1-84a9cd99cb6a5e1a092150be4611ad4c.png";